import { PreviewProps } from './Types'
import Styles from './DefaultPreview.module.scss'
import { Color } from 'types'

export const DefaultPreview = ({ brandKit }: PreviewProps) => {
  const { brand_visual_kit } = brandKit
  const { primary_color_palette } = brand_visual_kit || { primary_color_palette: { colors: [] } }
  return (
    <div className={Styles.preview} data-testid="brand_kit_default_preview">
      {primary_color_palette.colors.map((color: Color, index: number) => (
        <div
          key={index}
          style={{
            backgroundColor: color.hex,
            height: '100%',
            width: `${100 / primary_color_palette.colors.length}%`,
          }}
        />
      ))}
    </div>
  )
}
